var _mask, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0-reset",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 3,
    width: 16,
    height: 18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.642 6.35146C16.012 4.72146 13.702 3.78146 11.162 4.04146C7.49196 4.41146 4.47196 7.39146 4.06196 11.0615C3.51196 15.9115 7.26196 20.0015 11.992 20.0015C15.182 20.0015 17.922 18.1315 19.202 15.4415C19.522 14.7715 19.042 14.0015 18.302 14.0015C17.932 14.0015 17.582 14.2015 17.422 14.5315C16.292 16.9615 13.582 18.5015 10.622 17.8415C8.40196 17.3515 6.61196 15.5415 6.14196 13.3215C5.30196 9.44146 8.25196 6.00146 11.992 6.00146C13.652 6.00146 15.132 6.69146 16.212 7.78146L14.702 9.29146C14.072 9.92146 14.512 11.0015 15.402 11.0015H18.992C19.542 11.0015 19.992 10.5515 19.992 10.0015V6.41146C19.992 5.52146 18.912 5.07146 18.282 5.70146L17.642 6.35146Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0-reset)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D0D3D9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.b0b067046b4fa4f8f2b5eb5a77704d24.svg";
export { ForwardRef as ReactComponent };